export default "/_next/static/images/bottom-texture-4-44fd8a069a3cdc7adc7a3836abbf4b11.svg";